import {Show, VStack} from 'platform/foundation';

import {FilterFeatures} from '../../Filters/components/FilterFeatures/FilterFeatures';
import {FilterMakesModels} from '../../Filters/components/FilterMakesModels/FilterMakesModels';
import {FilterSeller} from '../../Filters/components/FilterSeller/FilterSeller';
import {FilterSpecification} from '../../Filters/components/FilterSpecification/FilterSpecification';
import {FilterStatistics} from '../../Filters/components/FilterStatistics/FilterStatistics';
import {FilterFieldsContext} from '../contexts/FilterFieldsContext';
import {FilterFieldName} from '../utils/getFilterSections';

const MAKE_FIELDS: FilterFieldName[] = [
  'make',
  'model',
  'vehicleCategory',
  'hideSuspicious',
  'hitlistOnly',
  'hideBlacklist',
];
const SELLER_FIELDS: FilterFieldName[] = [
  'sellerCountry',
  'originCountry',
  'sellerServer',
  'sellerType',
  'auctionType',
  'carStatus',
  'auctionServer',
  'avgNumberAds',
  'address',
  'radius',
];
const MARKET_FIELDS: FilterFieldName[] = [
  'priceCZK',
  'margin',
  'marginPercent',
  'daysOnDisplay',
  'liquidity',
  'pricePosition',
  'reclaimableVat',
];

export function FilterControls(props: {fields: FilterFieldName[]; isCompact?: boolean}) {
  const fields = [...props.fields];
  if (fields.includes('model') && !fields.includes('make')) {
    fields.push('make');
  }
  if (fields.includes('marginPercent') && !fields.includes('margin')) {
    fields.push('margin');
  }
  const hasAny = (fields: FilterFieldName[]) =>
    fields.some((field) => props.fields.includes(field));
  const specificationFields = props.fields.filter(
    (field) => ![...MAKE_FIELDS, ...SELLER_FIELDS, ...MARKET_FIELDS, 'features'].includes(field)
  );

  return (
    <FilterFieldsContext.Provider value={fields}>
      <VStack spacing={6}>
        <Show when={hasAny(MAKE_FIELDS)}>
          <FilterMakesModels
            isCompact={props.isCompact}
            data-testid="sourcing-filter-editor-makes"
          />
        </Show>
        <Show when={specificationFields.length > 0}>
          <FilterSpecification
            isCompact={props.isCompact}
            data-testid="sourcing-filter-editor-specification"
          />
        </Show>
        <Show when={hasAny(MARKET_FIELDS)}>
          <FilterStatistics
            isCompact={props.isCompact}
            data-testid="sourcing-filter-editor-statistics"
          />
        </Show>
        <Show when={hasAny(SELLER_FIELDS)}>
          <FilterSeller isCompact={props.isCompact} data-testid="sourcing-filter-editor-seller" />
        </Show>
        <Show when={props.fields.includes('features')}>
          <FilterFeatures data-testid="sourcing-filter-editor-features" />
        </Show>
      </VStack>
    </FilterFieldsContext.Provider>
  );
}
